var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 84,
    viewBox: "0 0 107 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_?\xEB\x8D\x89\xEC\x94\xA0??1",
    clipPath: "url(#clip0_167_1657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.1448 9.45386C67.6801 6.89734 64.7506 5.49907 61.873 6.10429C59.2136 6.66777 56.4087 6.97038 53.4896 6.97038C50.5705 6.97038 47.7656 6.66777 45.1062 6.10429C42.2286 5.49907 39.3095 6.89734 37.8344 9.45386L0.924553 73.7008C-1.7037 78.2817 1.57902 83.9999 6.84591 83.9999H100.154C105.421 83.9999 108.704 78.2817 106.075 73.7008L69.1448 9.45386Z",
    fill: "#1FCE00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M61.8938 1.34607H43.9843V6.97042H61.8938V1.34607Z",
    fill: "#8DC1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.8345 23.833L70.2668 5.44693C68.7605 2.54606 66.5893 0.302579 62.6314 1.26258C62.2782 1.25214 60.7199 2.04519 60.3252 2.3478C55.0894 6.50084 49.0122 4.83127 46.7891 2.26432C46.3736 1.78432 45.5321 0.76171 44.9712 0.469536C42.0728 -1.03307 38.385 1.2104 36.6501 4.19475L25.0463 24.0939C22.8648 27.84 24.1114 32.6504 27.8408 34.8417C28.4018 35.1756 28.9939 35.4156 29.586 35.593C29.7003 35.6348 29.8354 35.6661 29.9912 35.7078C30.0016 35.7078 30.012 35.7078 30.0223 35.7078C32.2039 36.2921 37.9694 37.0852 45.9373 32.6608C47.2566 31.9304 48.7421 31.5443 50.2485 31.5965C51.7963 31.6487 53.3338 32.1808 53.3338 34.0591L53.313 37.3252C53.2819 41.6661 56.7723 45.2034 61.0835 45.2348C65.0103 45.2556 68.2722 42.3652 68.854 38.5774V38.6191C68.854 38.6191 68.8644 38.5774 68.8644 38.4939C68.8955 38.3061 68.9059 38.1287 68.9267 37.9408C69.1033 36.9808 69.8097 35.353 72.5522 35.3113C73.8819 35.3634 75.2428 35.0921 76.4998 34.4243C80.3331 32.4104 81.8083 27.6626 79.8033 23.8226L79.8345 23.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.4135 61.6905C82.1708 61.6905 82.7848 61.0738 82.7848 60.3131C82.7848 59.5523 82.1708 58.9357 81.4135 58.9357C80.6562 58.9357 80.0422 59.5523 80.0422 60.3131C80.0422 61.0738 80.6562 61.6905 81.4135 61.6905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M77.2893 67.2C78.0466 67.2 78.6606 66.5833 78.6606 65.8226C78.6606 65.0619 78.0466 64.4452 77.2893 64.4452C76.532 64.4452 75.9181 65.0619 75.9181 65.8226C75.9181 66.5833 76.532 67.2 77.2893 67.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.5273 67.2C86.2846 67.2 86.8985 66.5833 86.8985 65.8226C86.8985 65.0619 86.2846 64.4452 85.5273 64.4452C84.77 64.4452 84.156 65.0619 84.156 65.8226C84.156 66.5833 84.77 67.2 85.5273 67.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.5865 61.6905C26.3438 61.6905 26.9578 61.0738 26.9578 60.3131C26.9578 59.5523 26.3438 58.9357 25.5865 58.9357C24.8292 58.9357 24.2152 59.5523 24.2152 60.3131C24.2152 61.0738 24.8292 61.6905 25.5865 61.6905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.4727 67.2C22.2301 67.2 22.844 66.5833 22.844 65.8226C22.844 65.0619 22.2301 64.4452 21.4727 64.4452C20.7154 64.4452 20.1015 65.0619 20.1015 65.8226C20.1015 66.5833 20.7154 67.2 21.4727 67.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.7107 67.2C30.468 67.2 31.0819 66.5833 31.0819 65.8226C31.0819 65.0619 30.468 64.4452 29.7107 64.4452C28.9534 64.4452 28.3394 65.0619 28.3394 65.8226C28.3394 66.5833 28.9534 67.2 29.7107 67.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M42.5819 60.6991C44.0965 60.6991 45.3244 59.4658 45.3244 57.9444C45.3244 56.4229 44.0965 55.1896 42.5819 55.1896C41.0672 55.1896 39.8393 56.4229 39.8393 57.9444C39.8393 59.4658 41.0672 60.6991 42.5819 60.6991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M61.8003 60.6991C63.315 60.6991 64.5428 59.4658 64.5428 57.9444C64.5428 56.4229 63.315 55.1896 61.8003 55.1896C60.2856 55.1896 59.0578 56.4229 59.0578 57.9444C59.0578 59.4658 60.2856 60.6991 61.8003 60.6991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M52.3573 68.5669C49.1784 68.5669 46.9346 65.0191 46.8411 64.8626L48.3889 63.8817C48.8876 64.6748 50.5601 66.72 52.3573 66.72C53.5935 66.72 54.8089 65.76 55.9828 63.8817L57.5307 64.8521C56.0036 67.3043 54.2583 68.5565 52.3469 68.5565L52.3573 68.5669Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_1657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage4);
export default __webpack_public_path__ + "static/media/cardImage4.93fd617aea4d9415bd3eba1fe7e6a72b.svg";
export { ForwardRef as ReactComponent };